import * as tokens from '@utmost.co/utmost-design-tokens';
import { Components } from '../../../styles';

export const cardTheme = {
  MuiCard: {
    styleOverrides: {
      root: {
        backgroundColor: tokens.colorSurface,
        color: tokens.colorOnSurface,
        '&.BpCard-prominent': {
          backgroundColor: '#F4F3F7'
        }
      }
    }
  }
} satisfies Components;
